import * as React from 'react';
import Div from "@jumbo/shared/Div";
import ContentWrapper from 'app/components/ContentWrapper/ContentWrapper';
import { Typography } from "@mui/material";
import MobileFooter from 'app/components/MobileFooter/MobileFooter';
import MobileHeader from 'app/components/MobileHeader/MobileHeader';
import MobileButton from 'app/components/MobileButton/MobileButton';
import InputIcon from 'app/components/InputIcon/InputIcon';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import DescriptionIcon from '@mui/icons-material/Description';
import Checkbox from '@mui/material/Checkbox';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Link from "@mui/material/Link";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import InputSearch from 'app/components/InputSearch/InputSearch';
import Card from '@mui/material/Card';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Chip from '@mui/material/Chip';
import TuneIcon from '@mui/icons-material/Tune';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import InputOtp from 'app/components/InputOtp/InputOtp';
import { useNavigate } from "react-router-dom";


const WebViewProfile = () => {

	const [openModal, setOpenModal] = React.useState(false);
	const [openSnK, setOpenSnk] = React.useState(false);
	const [scroll, setScroll] = React.useState('paper');

	const handleClickOpenSnk = (scrollType) => () => {
		setOpenSnk(true);
		setScroll(scrollType);
	};

	const handleClose = () => {
		setOpenSnk(false);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
	};

	const descriptionElementRef = React.useRef(null);
	React.useEffect(() => {
		if (openSnK) {
			const { current: descriptionElement } = descriptionElementRef;
			if (descriptionElement !== null) {
				descriptionElement.focus();
			}
		}
	}, [openSnK]);

	const handleClickModal = () => {
		setOpenModal(true);
	};

	// handle search
	const handleOnChange = React.useCallback(() => {

	}, []);

	const navigate = useNavigate();

	const navigateToLogin = () => {
		// 👇️ navigate to /demoLoginWebView
		navigate('/webViewLogin');
	};


	return (
		<Div className='page-wrapper-mobile'>

			{/* 🔥 HEADER */}
			<MobileHeader
				backIcon
				headerTx={"Demo Component"}
			/>

			{/* 🔥 CONTENT */}
			<ContentWrapper isMobile>

				{/* 🔥 search and filter button */}
				<Div sx={{
					mb: 2,
					display: 'flex',
					flexDirection: 'row'
				}}>
					<InputSearch onChange={handleOnChange} sx={{ marginRight: '16px' }} />
					<IconButton
						edge="start"
						color="inherit"
						aria-label="close"
					>
						<TuneIcon />
					</IconButton>
				</Div>

				{/* 🔥 typography */}
				<Typography fontSize={16} fontWeight={600}>Silakan Lengkapi Data Diri Anda</Typography>
				<Typography fontSize={14} fontWeight={500}>Silakan Lengkapi Data Diri Anda</Typography>

				{/* 🔥 input with icon left/right */}
				<Div sx={{ mt: 2 }}>
					<Div sx={{ mb: 2 }}>
						<InputIcon
							inputLabel={"Nama Lengkap Agen"}
							placeholder={"Nama Lengkap Agen"}
							leftIcon={<AccountCircleIcon sx={{ fontSize: 24 }} />}
						/>
					</Div>
					<Div sx={{ mb: 2 }}>
						<InputIcon
							inputLabel={"Nama Lengkap Agen"}
							placeholder={"Nama Lengkap Agen"}
							leftIcon={<DescriptionIcon sx={{ fontSize: 24 }} />}
						/>
					</Div>

					{/* 🔥 input otp 	*/}
					<Div sx={{ mb: 2, display: 'flex', flexDirection: 'row' }}>
						<InputOtp />
						<InputOtp />
						<InputOtp />
						<InputOtp />
						<InputOtp />
						<InputOtp />
					</Div>

					{/* 🔥 card (include chips, row - col)*/}
					<Div sx={{ mb: 2 }}>
						<Card variant="outlined" sx={{
							padding: "12px"
						}}>
							<Row className='p-2'>
								<Col>
									<Typography fontSize={12}>Nama Referrer</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>Raditya Putra</Typography>
								</Col>
							</Row>
							<Row className='p-2 bt-4'>
								<Col>
									<Typography fontSize={12}>Nama Referrer</Typography>
								</Col>
								<Col>
									<Typography fontSize={12} fontWeight={600} textAlign={"right"}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl.</Typography>
								</Col>
							</Row>
							<Row className='p-2 bt-4'>
								<Col>
									<Typography fontSize={12}>Status</Typography>
								</Col>
								<Col className='flex-justify-end'>
									<Chip label="wait" size="small" color='success' sx={{ borderRadius: '5px' }} />
								</Col>
							</Row>
							<Row className='p-2 bt-4'>
								<Col className='flex-justify-start'>
									<Typography fontSize={12}>Lihat Detail</Typography>
								</Col>
								<Col>
									<MobileButton
										sx={{
											textAlign: 'right'
										}}
										size={'small'}
										preset={"round"}
										onClick={handleClose}
										btnText={"Detail"}
									/>
								</Col>
							</Row>
						</Card>
					</Div>

					{/* 🔥 RADIO BUTTON - CHECKBOX */}
					<Div>
						<FormControl>
							<FormLabel id="demo-row-radio-buttons-group-label">
								<Typography fontSize={12}>Gender</Typography>
							</FormLabel>
							<RadioGroup
								row
								aria-labelledby="demo-row-radio-buttons-group-label"
								name="row-radio-buttons-group"
							>
								<FormControlLabel value="female" control={<Radio />} label="Female" />
								<FormControlLabel value="male" control={<Radio />} label="Male" />
								<FormControlLabel value="other" control={<Radio />} label="Other" />
								<FormControlLabel
									value="disabled"
									disabled
									control={<Radio />}
									label="other"
								/>
							</RadioGroup>
						</FormControl>
					</Div>
					<Div className='flex-align-top'>
						<Checkbox
							size='small'
							sx={{
								'&.MuiButtonBase-root': { padding: 0 },
								'&.Mui-checked': { color: '#C21B17' }
							}}
						/>
						<Typography fontSize={10} ml={1}>Saya menyetujui Syarat dan Ketentuan dan Kebijakan Privasi yang berlaku. Klik Disini untuk mempelajari <Link onClick={handleClickOpenSnk('paper')}>Syarat dan Ketentuan</Link> yang berlaku.</Typography>
					</Div>

					{/* 🔥 OPEN MODAL */}
					<Div sx={{ mt: 2 }}>
						<MobileButton preset={"round"} onClick={handleClickModal} btnText={"Open Modal Example"} btnStyle={{ backgroundColor: '#F1644A' }} />
					</Div>
				</Div>
			</ContentWrapper>

			{/* 🔥 FOOTER */}
			<MobileFooter>
				<MobileButton
					btnText={"Submit"}
					onClick={navigateToLogin}
				/>
			</MobileFooter>


			{/* 🔥 MODAL */}

			<Dialog
				onClose={handleCloseModal}
				open={openModal}
				PaperProps={{ sx: { borderRadius: '20px' } }}
			>
				<DialogTitle>Modal Example</DialogTitle>
			</Dialog>

			{/* dialog SnK */}
			<Dialog
				open={openSnK}
				onClose={handleClose}
				scroll={scroll}
				aria-labelledby="scroll-dialog-title"
				aria-describedby="scroll-dialog-description"
				PaperProps={{ sx: { borderRadius: '20px' } }}
			>
				<DialogTitle id="scroll-dialog-title" sx={{ backgroundColor: "#C21B17", color: "#FFFFFF", marginBottom: 0 }}>
					<Div sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
						<IconButton
							edge="start"
							color="inherit"
							onClick={handleClose}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
						Syarat dan Ketentuan
					</Div>
				</DialogTitle>
				<DialogContent dividers={scroll === 'paper'}>
					<DialogContentText
						id="scroll-dialog-description"
						ref={descriptionElementRef}
					>
						<ol>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
							<li><Typography fontSize={14}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In eu tempus elit, et consequat nisl. Quisque gravida semper rhoncus.</Typography></li>
						</ol>
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<MobileButton preset={"round"} onClick={handleClose} btnText={"Tidak Setuju"} btnStyle={{ backgroundColor: '#F1644A' }} />
					<MobileButton preset={"round"} onClick={handleClose} btnText={"Setuju"} />
				</DialogActions>
			</Dialog>
		</Div>

	);
};

export default WebViewProfile;